// Controllers registered on public marketing/chapter pages — kept to
// exactly what those pages use (verified against app/views/pages,
// app/views/chapters, and app/views/members). If a public view starts
// using another controller, add it here too, or it won't connect.
import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import LazyVideoController from "./lazy_video_controller"
application.register("lazy-video", LazyVideoController)

import MemberApplicationFormController from "./member_application_form_controller"
application.register("member-application-form", MemberApplicationFormController)

import MemberCardController from "./member_card_controller"
application.register("member-card", MemberCardController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)
